import React, { useMemo } from "react";
import Section from "../../../../common/components/Dashboard/Section";
import { useDashboardTrackingMostActiveModule } from "../../../../common/API/hooks";
import LoadingComponent from "../../../../common/components/LoadingComponent";
import { Typography } from "@mui/material";
import MostVisitedDashboardsChart from "./MostVisitedDashboardsChart";
import { useSelectorValue } from "../../../customDashboards/common/providers/selectorProvider";
import { formatDateToObjectFromAndTo } from "../utils";

export default function MostVisitedDashboards({ username }) {
    const date = useSelectorValue("date");
    const dateTo = useSelectorValue("dateTo");
    const module = useSelectorValue("module");
    const dateRange = formatDateToObjectFromAndTo(date, dateTo);

    const filters = useMemo(
        () => ({
            ...dateRange,
            username: username || null,
            module_name: module === "All" ? null : module,
        }),
        [dateRange, username, module]
    );

    const { data, isLoading, error } = useDashboardTrackingMostActiveModule(filters);

    const renderContent = () => {
        if (isLoading) return <LoadingComponent />;
        if (error) return <Typography variant="h5">Error loading data</Typography>;
        if (!data || data.length === 0)
            return <Typography variant="body2" color="text.secondary" p={2}>No data available.</Typography>;

        return <MostVisitedDashboardsChart data={data} />;
    };

    return (
        <Section title={"Most Visited Dashboards"} isCollapsible={true}>
            {renderContent()}
        </Section>
    );
}

